import { type ThemeOptions } from '@mui/material';

export function createSliderStyles() {
  return {
    MuiSlider: {
      styleOverrides: {
        thumb: ({ theme }) => ({
          '&.Mui-focusVisible': {
            '&:not(.Mui-active)': {
              '&::after': {
                borderRadius: `${theme.ui.focus.borderRadius}`,
                height: 'inherit',
                outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
                outlineOffset: `${theme.ui.focus.outlineOffset}`,
                width: 'inherit',
              },
              boxShadow: 'none',
            },
          },
        }),
        valueLabel: ({ theme }) => ({
          '&': {
            background: 'none',
            padding: 0,
          },
          '&::before': {
            background: theme.palette.grey[600],
          },
        }),
      },
    },
  } as ThemeOptions['components'];
}
